import { render, staticRenderFns } from "./CountryListItem.vue?vue&type=template&id=c21afafc"
import script from "./CountryListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountryListItem.vue?vue&type=style&index=0&id=c21afafc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports